import { useState } from "react";
import { toast } from "sonner";
import PublicShell from "@/components/PublicShell";
import { VideoSlot } from "@/components/VideoSlot";
import { api } from "@/lib/api";
import { Instagram, Facebook, Music2 } from "lucide-react";

export default function ContactPage() {
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/messages", f);
      toast.success("Message sent. I read every one — thank you.");
      setF({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to send");
    } finally { setSending(false); }
  };
  return (
    <PublicShell>
      <section className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <VideoSlot page="contact" spot="top" className="mb-16" />
        <div className="overline text-mute mb-4">Say Hello</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light leading-tight mb-6 text-ink">Questions, ideas, or just to talk about paint.</h1>
        <p className="text-ink-soft leading-relaxed mb-12 max-w-2xl">
          The studio inbox is where all conversations begin. Reach out about a piece, a size, shipping, or anything else.
        </p>
        <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
          <div className="grid md:grid-cols-2 gap-6">
            <input required className="input-line" placeholder="Your name" data-testid="contact-name" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} />
            <input required type="email" className="input-line" placeholder="Email" data-testid="contact-email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} />
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <input className="input-line" placeholder="Phone (optional)" data-testid="contact-phone" value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })} />
            <input className="input-line" placeholder="Subject" data-testid="contact-subject" value={f.subject} onChange={e => setF({ ...f, subject: e.target.value })} />
          </div>
          <textarea required rows={6} className="input-line" placeholder="Your message" data-testid="contact-message" value={f.message} onChange={e => setF({ ...f, message: e.target.value })} />
          <div className="pt-6">
            <button className="btn-ink" type="submit" disabled={sending} data-testid="contact-submit">{sending ? "Sending…" : "Send Message"}</button>
          </div>
        </form>
        <div className="mt-16 pt-10 border-t border-ink-10">
          <div className="overline text-mute mb-4">Also here</div>
          <div className="flex gap-6">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-accent"><Instagram size={18}/> Instagram</a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-accent"><Facebook size={18}/> Facebook</a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-accent"><Music2 size={18}/> TikTok</a>
          </div>
        </div>
        <VideoSlot page="contact" spot="bottom" className="mt-20" />
      </section>
    </PublicShell>
  );
}
